<div class="error-page-wrapper">
  <img class="logo img-fluid" src="./assets/img/logo.png" />
  <section>
    We're sorry, but we couldn't find the page you were looking for.
  </section>
</div>
